import React, { useState, useEffect } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { toggleWallet } from "../../redux/walletReducer";

//Assets
import wallet_bg from "../../assets/wallet_bg.svg";
import cross_small from "../../assets/icons/cross_small.svg";

//Local Components
import WalletList from "./walletList";
import Info from "./Info";
import { MOBILE } from "../../constants/breakpoints";

function WalletConnect() {
  const walletState = useSelector((state: RootState) => state.walletState);
  const dispatch = useDispatch();

  const [selectedPane, setselectedPane] = useState<"wallets" | "info">(
    "wallets"
  );

  if (!walletState.walletToggle) {
    return <></>;
  }

  return (
    <section
      id="wc_bg"
      css={css`
        display: flex;
        width: 100%;
        height: 100vh;
        position: fixed;
        background: rgba(27, 31, 36, 0.74);
        z-index: 1000;
        justify-content: center;
        align-items: center;
      `}
      onClick={(e) => {
        if ((e.target as any).id === "wc_bg") {
          dispatch(toggleWallet());
        }
      }}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          background: url(${wallet_bg});
          background-size: cover;
          width: 1074px;
          height: 642px;
          box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
            0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481),
            0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185),
            0px 20px 13px rgba(0, 0, 0, 0.035),
            0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815),
            0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);
          border-radius: 24px;
          padding: 64px 65px;
          position: relative;

          @media (max-width: ${MOBILE}px) {
            width: 93%;
            padding: 32px 23px;
          }
        `}
      >
        <img
          css={css`
            position: absolute;
            right: 30px;
            top: 30px;
            width: 16px;
            height: 16px;
            cursor: pointer;
          `}
          onClick={() => {
            dispatch(toggleWallet());
          }}
          src={cross_small}
          alt=""
        />
        <h1
          css={css`
            font-weight: 700;
            font-size: 32px;
            margin: 0;
            margin-bottom: 48px;
            @media (max-width: ${MOBILE}px) {
              margin-bottom: 16px;
              font-weight: 700;
              font-size: 24px;
            }
          `}
        >
          Connect a Wallet
        </h1>
        {/* Desktop Varients */}
        <div
          css={css`
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: space-between;
            @media (max-width: ${MOBILE}px) {
              display: none;
            }
          `}
        >
          {/* wallet list (left side) */}
          <WalletList />
          {/* Info (right side) */}
          <Info />
        </div>
        {/* Mobile Varient */}
        <div
          css={css`
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: space-between;
            @media (min-width: ${MOBILE+1}px) {
              display: none;
            }
          `}
        >
          {/* wallet list (left side) */}
          {selectedPane === "wallets" && (
            <WalletList
              switchToInfo={() => {
                setselectedPane("info");
              }}
            />
          )}
          {/* Info (right side) */}
          {selectedPane === "info" && (
            <Info
              switchToWallets={() => {
                setselectedPane("wallets");
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default WalletConnect;
